import * as React from "react";
import PasosContainer from "../conteiners/pasos-container";

export default function PasosPage() {
  return <PasosContainer></PasosContainer>;
}
